import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import {
  isApplicationAccepted,
} from 'common/householdApplication/applicationHelpers';

import SrButton, {
  SR_BUTTON_THEME_ADOBE_YELLOW,
} from 'client/components/SrButton/SrButton';
import SrStaticFooter from 'client/components/SrStaticFooter';

import SrPartnerApprovalContext from './SrPartnerApprovalContext';

const SrPartnerApprovalSubmit = ({
  isBusy,
  onNext,
}) => {
  const {
    householdApplications,
  } = useContext(SrPartnerApprovalContext);

  const householdIsApproved = householdApplications.every(isApplicationAccepted);

  return (
    <SrStaticFooter>
      <SrButton
        theme={SR_BUTTON_THEME_ADOBE_YELLOW}
        onClick={onNext}
        disabled={isBusy}
      >
        {householdIsApproved ? 'Back' : 'Approve & Request Funds'}
      </SrButton>
    </SrStaticFooter>
  );
};

SrPartnerApprovalSubmit.propTypes = {
  isBusy: PropTypes.bool,
  onNext: PropTypes.func.isRequired,
};

SrPartnerApprovalSubmit.displayName = 'SrPartnerApprovalSubmit';

export default SrPartnerApprovalSubmit;
